"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabs = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
const media_1 = require("../basic/media");
exports.tabs = (0, basic_1.applyBase)({
    tabControlsWrap: {
        borderColor: colors_1.colors.lightGreySecond,
        flexGrow: 1,
        position: 'relative',
        '.checked': {
            borderBottomColor: colors_1.colors.redSecondary,
            color: colors_1.colors.primary,
        },
    },
    tabControl: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.TABS), { flexDirection: ['column', 'row'], justifyContent: 'center', alignItems: 'center', height: ['50px', '58px'], flexGrow: [1, 0], letterSpacing: ['0.3px', '0.5px'], backgroundColor: 'white', borderBottomWidth: ['2px', '3px'], borderBottomColor: 'transparent', borderBottomStyle: 'solid', transition: 'fast', '.icon': { width: ['48px', '24px'], height: ['20px', '24px'] }, [media_1.media.mobile]: {
            textAlign: 'center',
            px: 1,
        }, '.icon-wrap': {
            display: 'flex',
            mb: '2px',
            mr: [null, '10px'],
        }, '.tab-label': {
            whiteSpace: [null, 'nowrap'],
        } }),
});
//# sourceMappingURL=tabs.js.map